import React, { createContext, useCallback, useContext } from "react";
import axiosInstance from "../AxiosInstance";

const AnalyticsContext = createContext({
  trackPageHit: () => {},
});

export const AnalyticsProvider = ({ children }) => {
  const trackPageHit = useCallback(async (pageKey) => {
    const endpointMap = {
      home: "/page/analytics/home-hit",
      register: "/page/analytics/register-hit",
      login: "/page/analytics/login-hit",
    };

    const path = endpointMap[pageKey];
    if (!path) return;

    try {
      await axiosInstance.post(path, null);
    } catch (err) {
      console.warn("[Analytics] Failed:", err?.message);
    }
  }, []);

  const fetchOverviewAnalytics = useCallback(async () => {
    const response = await axiosInstance.get(
      "/v1/admin/analytics/overview"
    );
    return response.data;
  }, []);

  return (
    <AnalyticsContext.Provider 
    value={{ 
      trackPageHit,
      fetchOverviewAnalytics,
      }}
      >
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalytics = () => useContext(AnalyticsContext);
